import pushRouteClient from 'root/src/client/logic/route/util/pushRouteClient'
import { ACCOUNT_SETTINGS_ROUTE_ID } from 'root/src/shared/descriptions/routes/routeIds'
import { SET_USER_NOTIFICATION_SETTINGS } from 'root/src/shared/descriptions/endpoints/endpointIds'
import apiRequest from 'root/src/client/logic/api/thunks/apiRequest'

export default formData => async (dispatch) => {
	await dispatch(apiRequest(SET_USER_NOTIFICATION_SETTINGS, formData))
	return pushRouteClient({ routeId: ACCOUNT_SETTINGS_ROUTE_ID })
}
